import {
  Button,
  Col,
  Descriptions,
  Input,
  Modal,
  Row,
  Space,
  Table,
} from 'antd';
import { InputGroup } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import Excel from 'components/table/excel';
import CreateCancel from 'components/forms/CreateCancel';
import CustomPagination from 'components/table/pagination';
import DashboardContext from 'Context';
import FormAppDiscount from './FormAppDiscount';

export default function AppDiscount() {
  const { SohwaddFrom, urldashboard, authentication, handelAdd } =
    useContext(DashboardContext);

  // table data
  const [data, setData] = useState([]);
  const [record, setRecord] = useState({});
  const [headers, setHeaders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  // action modals
  const [moreInfoModal, setMoreInfoModal] = useState(false);

  useEffect(() => {
    if (!moreInfoModal) {
      getAppDiscountList({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        searchValue,
      });
      setRecord({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handelAdd, moreInfoModal]);

  const getAppDiscountList = async ({ page, pageSize, searchValue }) => {
    setLoading(true);
    try {
      let url = '/appDiscount/get';
      const res = await Axios.post(
        urldashboard + url,
        JSON.stringify({ page, pageSize, search: searchValue }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      setHeaders(data?.headers?.map((item) => item.label));
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getAppDiscountList({
      page: newPage,
      pageSize: newPageSize,
      searchValue,
    });
  };

  const search = () => {
    getAppDiscountList({
      page: 1,
      pageSize: 10,
      searchValue,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'تاریخ شروع',
      dataIndex: 'persianStartDate',
      key: 'persianStartDate',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'تاریخ پایان',
      dataIndex: 'persianEndDate',
      key: 'persianEndDate',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'درصد تخفیف خانم',
      dataIndex: 'femalePercentage',
      key: 'femalePercentage',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'درصد تخفیف آقا',
      dataIndex: 'malePercentage',
      key: 'malePercentage',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'وضعیت',
      dataIndex: 'isActive',
      key: 'isActive',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => (
        <span>
          {value ? (
            <i
              className='mdi mdi-check'
              style={{ color: 'green', fontSize: '1.5rem' }}
            ></i>
          ) : (
            <i
              className='mdi mdi-close'
              style={{ color: 'red', fontSize: '1.5rem' }}
            ></i>
          )}
        </span>
      ),
    },
    {
      title: 'اطلاعات بیشتر',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => showInfoModal(record)}>
          <i className='mdi mdi-eye'></i>
        </Button>
      ),
    },
  ];

  // actions

  const showInfoModal = (data) => {
    setRecord(data);
    setMoreInfoModal(true);
  };

  return (
    <>
      <CreateCancel />

      {SohwaddFrom ? (
        <div
          style={{
            padding: '20px',
            borderRadius: '10px',
            backgroundColor: '#ffff',
          }}
        >
          <FormAppDiscount />
        </div>
      ) : (
        <>
          <Row
            gutter={20}
            style={{
              marginTop: 25,
            }}
          >
            <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
              <InputGroup>
                <Input
                  placeholder='جستجوی سریع'
                  name='searchValue'
                  onChange={(e) => setSearchValue(e.target.value)}
                  style={{
                    height: '3rem',
                    width: '90%',
                    display: 'table-cell',
                  }}
                />
                <Button
                  onClick={search}
                  style={{
                    height: '3rem',
                    width: '10%',
                    display: 'table-cell',
                    padding: 0,
                  }}
                >
                  <i className='mdi mdi-magnify'></i>
                </Button>
              </InputGroup>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
              <Space
                wrap
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  width: '100%',
                }}
              >
                <Excel
                  data={data}
                  headers={headers}
                  fileName={'تخفیفات_استفاده_از_اپلیکیشن'}
                />
              </Space>
            </Col>
          </Row>

          <Table
            size='small'
            style={{ textAlign: 'right', marginTop: 10 }}
            rowClassName={() => 'center'}
            columns={columns}
            bordered={true}
            dataSource={data}
            loading={loading}
            pagination={false}
            locale={{
              emptyText: 'موردی یافت نشد',
            }}
          />

          {!loading && (
            <CustomPagination
              totalRecord={totalRecord}
              pagination={pagination}
              handlePagination={handlePagination}
            />
          )}

          <Modal
            title='اطلاعات بیشتر'
            closable={false}
            open={moreInfoModal}
            onCancel={() => setMoreInfoModal(false)}
            footer={[
              <Button key='back' onClick={() => setMoreInfoModal(false)}>
                بستن
              </Button>,
            ]}
            bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
          >
            <Descriptions bordered column={1} size={'small'}>
              <Descriptions.Item label='تاریخ شروع'>
                {record?.persianStartDate
                  ? record?.persianStartDate
                  : 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='تاریخ پایان'>
                {record?.persianEndDate
                  ? record?.persianEndDate
                  : 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='درصد تخفیف خانم'>
                {record?.femalePercentage}
              </Descriptions.Item>
              <Descriptions.Item label='درصد تخفیف آقا'>
                {record?.malePercentage}
              </Descriptions.Item>
              <Descriptions.Item label='فعال است؟'>
                {record?.isActive ? (
                  <i
                    className='mdi mdi-check'
                    style={{ color: 'green', fontSize: '1.5rem' }}
                  ></i>
                ) : (
                  <i
                    className='mdi mdi-close'
                    style={{ color: 'red', fontSize: '1.5rem' }}
                  ></i>
                )}
              </Descriptions.Item>
            </Descriptions>
          </Modal>
        </>
      )}
    </>
  );
}
